export class BaseEntity {
  creationDate?: Date;
  createUser?: number;
  updateDate?: Date;
  updateUser?: number;

}
